/** Límite y tipos permitidos para adjuntos (registro de visita y plan de inversión). */
export const MAX_FILE_SIZE_MB = 10;

export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'] as const;

/** Valor del atributo `accept` en inputs file (filtro en selector del SO). */
export const FILE_UPLOAD_ACCEPT = '.jpg,.jpeg,.png,.pdf,.doc,.docx';

const MAX_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

function extensionDeNombreArchivo(filename: string): string {
  const name = filename.trim();
  const i = name.lastIndexOf('.');
  if (i <= 0 || i === name.length - 1) return '';
  return name.slice(i + 1).toLowerCase();
}

const ALLOWED_SET = new Set(ALLOWED_EXTENSIONS.map((e) => e.toLowerCase()));

export function validateUploadFile(file: File): { valid: true } | { valid: false; message: string } {
  const ext = extensionDeNombreArchivo(file.name);
  if (!ext || !ALLOWED_SET.has(ext)) {
    return {
      valid: false,
      message: `Solo se permiten archivos: ${ALLOWED_EXTENSIONS.join(', ')}.`,
    };
  }
  if (file.size > MAX_BYTES) {
    return {
      valid: false,
      message: `El archivo supera el tamaño máximo de ${MAX_FILE_SIZE_MB} MB.`,
    };
  }
  return { valid: true };
}
